import { Box, Container, Grid, Typography } from "@mui/material";
import { designTokens } from "../../../theme/designTokens";
import { aboutCtaContent } from "../../../theme/aboutContent";

const { colors, spacing } = designTokens;

const AboutCtaSection = () => (
  <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: colors.white }}>
    <Container maxWidth={spacing.containerMax}>
      <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography
            component="h2"
            sx={{
              fontWeight: 900,
              fontSize: { xs: "2rem", md: "2.5rem" },
              lineHeight: "60px",
              color: colors.primary,
              textAlign: { xs: "center", md: "left" },
              mb: 2,
            }}
          >
            {aboutCtaContent.title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "1.125rem", md: "1.5rem" },
              lineHeight: "30px",
              color: colors.textPrimary,
              textAlign: { xs: "center", md: "left" },
              maxWidth: 819,
            }}
          >
            {aboutCtaContent.subtitle}
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-end" },
            }}
          >
            <Box
              component="img"
              src={aboutCtaContent.image}
              alt={aboutCtaContent.imageAlt}
              sx={{
                width: "100%",
                maxWidth: { xs: 320, md: 472 },
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default AboutCtaSection;
